import { Controller } from "@hotwired/stimulus"

// Generic hover/focus tooltip. Pair a trigger element with
// data-action="mouseenter->tooltip#show mouseleave->tooltip#hide
// focus->tooltip#show blur->tooltip#hide" with a data-tooltip-target="bubble"
// element holding the tooltip text.
export default class extends Controller {
  static targets = ["bubble"]

  show() {
    this.bubbleTarget.classList.remove("hidden")
  }

  hide() {
    this.bubbleTarget.classList.add("hidden")
  }
}
